<script>
import { archOptionsForChannel } from "@/utils/clientPlatforms";
export default {
    props: {
        fixedChannel: { type: String, default: "" },
        allowedChannels: { type: Array, default: () => [] },
    },
    computed: {
        archFilterOptions() {
            const ch = this.form.channel || this.fixedChannel;
            return archOptionsForChannel(ch);
        },
        channelOptions() {
            const labels = {
                qt_win: "Windows",
                qt_kylin: "麒麟V10",
                qt_mac: "macOS",
                qt_ios: "iOS",
            };
            const list = this.allowedChannels && this.allowedChannels.length
                ? this.allowedChannels
                : ["qt_win", "qt_kylin", "qt_mac", "qt_ios"];
            return list.map((value) => ({
                value,
                label: labels[value] || value,
            }));
        },
        showChannelFilter() {
            return !this.fixedChannel && this.channelOptions.length > 1;
        },
    },
    data() {
        return {
            form: {
                status: '',
                channel: '',
                name_keyword: '',
                platform_variant: '',
                cpu_arch: ''
            }
        };
    },
    mounted() {
        this.applyFixedChannel();
    },
    watch: {
        fixedChannel() {
            this.applyFixedChannel();
        },
    },
    methods: {
        applyFixedChannel() {
            if (this.fixedChannel) {
                this.form.channel = this.fixedChannel;
            }
        },
        onSubmit() {
            this.$emit('search');
        },
        getValue() {
            const v = Object.assign({}, this.form);
            if (this.fixedChannel) {
                v.channel = this.fixedChannel;
            }
            if (!v.channel) {
                delete v.channel;
            }
            if (!v.status) {
                delete v.status;
            }
            if (!v.name_keyword) {
                delete v.name_keyword;
            }
            if (!v.platform_variant) {
                delete v.platform_variant;
            }
            if (!v.cpu_arch) {
                delete v.cpu_arch;
            }
            return v;
        }
    }
};
</script>
<template>
    <el-form :inline="true" size="mini" :model="form" class="demo-form-inline">
        <el-form-item v-if="showChannelFilter" :label="$tt('平台')">
            <el-select v-model="form.channel" clearable :placeholder="$tt('请选择')">
            <el-option
                v-for="o in channelOptions"
                :key="o.value"
                :label="$tt(o.label)"
                :value="o.value"
            />
            </el-select>
        </el-form-item>
        <el-form-item :label="$tt('版本号')">
            <el-input v-model="form.name_keyword" clearable :placeholder="$tt('搜索历史版本')" />
        </el-form-item>
        <el-form-item v-if="archFilterOptions.length" :label="$tt('架构')">
            <el-select v-model="form.cpu_arch" clearable :placeholder="$tt('全部')">
            <el-option v-for="o in archFilterOptions" :key="o.value" :label="o.label" :value="o.value" />
            </el-select>
        </el-form-item>
        <el-form-item :label="$tt('状态')">
            <el-select v-model="form.status" clearable :placeholder="$tt('请选择')">
            <el-option :label="$tt('启用')" value="true"></el-option>
            <el-option :label="$tt('停用')" value="false"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="onSubmit">{{ $tt("查询") }}</el-button>
        </el-form-item>
    </el-form>
</template>
